import { TenantSettingModel } from '@app/shared/models/tenant-setting.model';
import { Action, createReducer, on, State } from "@ngrx/store";
import { tenantSettingChanged, tenantSettingError } from './tenant-setting.action';

const tenantSettingReducer = createReducer<TenantSettingModel, Action>(null,
    on(tenantSettingChanged, (state, tenant) => (tenant)),
    on(tenantSettingError, state => null)
);

export function reducer(state: State<TenantSettingModel> | undefined, action: Action) {
    return tenantSettingReducer(<any>state, action);
}